import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { useStore } from "../../../contexts/StoreProvider";
import { Field, Form, Formik } from "formik";
import Label from "../../../shared-components/Label/Label";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import {
  UserChangePasswordValidateSchema,
  forgetPasswordAuthSchema,
  forgetPasswordOTPSchema,
} from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormikFormOTPInput from "../../../shared-components/FormikFormHandlers/FormikFormOTPInput";
import { formatMessage } from "../../../translations/format-message";
import toast from "react-hot-toast";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import base64 from "base-64";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { maskEmail, resendOTPTimer } from "../../../constants/common-constants";
import { Button } from "react-bootstrap";

const StepTwoAuthForm = (props: any) => {
  const history = useHistory();
  const { authStore } = useStore();
  const { resetIsStepOneAuthenticatedState, ResendStepTwoVerificationOTPService, isStepTwoVerificationCodeSentState,
    resetIsStepTwoVerificationCodeSentState
   } = authStore;
  const [d1, setD1] = useState("");
  const [d2, setD2] = useState("");
  const [d3, setD3] = useState("");
  const [d4, setD4] = useState("");

  const initialValuesOTP = {
    Digit1: "",
    Digit2: "",
    Digit3: "",
    Digit4: "",
  };
  let interval: any;
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(resendOTPTimer);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (timer > 0) {
      setIsDisabled(true);
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setIsDisabled(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const submitOTPHandler = (values: any) => {
    let temp = { ...values };
    var otp = temp.Digit1 + temp.Digit2 + temp.Digit3 + temp.Digit4;
    if(temp.Digit1 === "" || temp.Digit2  === "" || temp.Digit3  === "" || temp.Digit4  === "" ){
        setShowError(true);
    }
    else{
        setShowError(false);
        setD1(temp.Digit1);
        setD2(temp.Digit2);
        setD3(temp.Digit3);
        setD4(temp.Digit4);
        props.loginHandler({ TwoStepVerificationCode: otp, Email: props.email });
    }
  };
  const resndOTPHandler = () => {
    ResendStepTwoVerificationOTPService(props.email);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
   * dependency "addUpdateUserSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (isStepTwoVerificationCodeSentState.success) {
        toast.success(formatMessage("otp_sent_successfully"));
        setTimer(resendOTPTimer);
        resetIsStepTwoVerificationCodeSentState();
    }
  }, [isStepTwoVerificationCodeSentState.success]);

  const handleInput = (event: any, nextInput: any) => {
    const inputLength = event.target.value.length;

    if (inputLength === 1 && nextInput) {
      document.getElementById(nextInput)?.focus();
    }
    if(inputLength == 0){
        setShowError(true)
    }
  };

  /* Returning JSX */
  return (
    <React.Fragment>
      <Formik
        initialValues={initialValuesOTP}
        validationSchema={forgetPasswordOTPSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          submitOTPHandler(values);
        }}
      >
        {({ values }) => {
        return (
        <Form className="login text-center">
          <div className="display">
            <h1 className="forgetPassHeading login_heading">
              <FormattedMessage id={"two_step_verification"} />
            </h1>
            <p className="text-muted mt-2"><FormattedMessage id={"sent_code_to_email"} /> <span className="text-dark">{maskEmail(props.email)}</span></p>
            
          </div>
          <div className="form-group mt-3 ">
            {/* <Label
              className="label-style col-sm-12 col-form-label"
              required={true}
              label="otp"
            /> */}
            <div className="justify-content-center d-flex">
              <Field
                testid="input1"
                className={`form-control otp mx-1 fw-bold ${(values.Digit1 == "" && showError) ? "is-invalid" : ""}`}
                name="Digit1"
                type="number"
                onInput={(e: any) => handleInput(e, "input2")}
                as={FormikFormOTPInput}
              />
              <Field
                testid="input2"
                className={`form-control otp mx-1 fw-bold ${(values.Digit2 == "" && showError) ? "is-invalid" : ""}`}
                name="Digit2"
                type="number"
                onInput={(e: any) => handleInput(e, "input3")}
                as={FormikFormOTPInput}
              />
              <Field
                testid="input3"
                className={`form-control otp mx-1 fw-bold ${(values.Digit3 == "" && showError) ? "is-invalid" : ""}`}
                name="Digit3"
                type="number"
                onInput={(e: any) => handleInput(e, "input4")}
                as={FormikFormOTPInput}
              />
              <Field
                testid="input4"
                className={`form-control otp mx-1 fw-bold ${(values.Digit4 == "" && showError) ? "is-invalid" : ""}`}
                name="Digit4"
                type="number"
                onInput={(e: any) => handleInput(e, null)}
                as={FormikFormOTPInput}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <LoaderButton
              type="button"
              className="me-1"
              onClick={() => {
                resetIsStepOneAuthenticatedState();
                clearInterval(interval);
                // history.push(RoutesConstants.Login);
              }}
              text={"button_cancel"}
              variant="secondary"
            />
            <LoaderButton
              type="submit"
              id="LoginButton"
              isLoading={props.isLoading}
              text="secure_login"
            />
          </div>
          <div className="mt-3 d-flex justify-content-center align-items-center">
            <span className="me-1 text-muted">
              <FormattedMessage id="did_not_get_code" />
            </span>
            <span>
                <a className={`${isDisabled ? 'text-muted pe-none' : ''}`} onClick={resndOTPHandler} >
                    <FormattedMessage id="resend_otp" />
                    {isDisabled && <span className="ms-2">({timer})</span>}
                </a>
            </span>
          </div>
        </Form>
            )
        }}  
      </Formik>
    </React.Fragment>
  );
};

export default observer(StepTwoAuthForm);
